// libs
import React from 'react';
import PropTypes from 'prop-types';
import 'array-flat-polyfill';

// component
import SearchCategories from './SearchCategories';
import SearchFilter from './SearchFilter';
import SearchInput from './SearchInput';
import SearchTags from './SearchTags';

// Styles
import './styles.scss';

function SearchFields(props, { t }) {
  const {
    activeType,
    filters,
    formValues,
    isLoading,
    isLoadingFilters,
    reset,
    resetSearch,
    selectArtist,
    updateActiveType,
    updateFormValues,
    updateSelectArtist,
  } = props;
  const currentFilters = filters.filter(filter => filter.filter_name === activeType) || [];
  const filterLabels = currentFilters.length !== 0 ?
    currentFilters[0].filters.map((filter) => (
      filter.categories.map((category) =>
        ((category.children.length !== 0) ?
          category.children.map((childCategory) => ({
            slug: `${filter.slug}__${childCategory.slug}`,
            name: childCategory.name,
          }))
          :
          {
            slug: `${filter.slug}__${category.slug}`,
            name: category.name,
          }
        ),
      )
    )).flat(Infinity) : [];
  return (
    <div>
      <h2 className="search__title">{t('pages.search.title')}</h2>
      <div className="search__sections">
        <SearchTags
          filterLabels={filterLabels}
          formValues={formValues}
          updateFormValues={updateFormValues}
          updateSelectArtist={updateSelectArtist}
          selectArtist={selectArtist}
          reset={reset}
          resetSearch={resetSearch}
        />
        <div className="search__fields">
          <div className="search__field__keywords">
            <SearchInput />
          </div>
          <div className="filters">
            <SearchCategories
              activeType={activeType}
              updateActiveType={updateActiveType}
              reset={reset}
            />
          </div>
          { !isLoadingFilters && currentFilters.length !== 0 &&
          <SearchFilter
            filter={currentFilters[0]}
            updateSelectArtist={updateSelectArtist}
            key={currentFilters[0].filter_name}
            selectArtist={selectArtist}
          />
          }
          <input
            type="submit"
            value={t('search.submitSearch')}
            className="button button--fill search__button"
            disabled={isLoading}
          />
        </div>
      </div>
    </div>
  );
}

SearchFields.contextTypes = {
  t: PropTypes.func,
};

SearchFields.propTypes = {
  activeType: PropTypes.string.isRequired,
  filters: PropTypes.array.isRequired,
  formValues: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingFilters: PropTypes.bool.isRequired,
  reset: PropTypes.func.isRequired,
  resetSearch: PropTypes.func.isRequired,
  selectArtist: PropTypes.array.isRequired,
  updateActiveType: PropTypes.func.isRequired,
  updateFormValues: PropTypes.func.isRequired,
  updateSelectArtist: PropTypes.func.isRequired,
};

export default SearchFields;



// WEBPACK FOOTER //
// ./src/app/components/pages/search/form/parts/SearchFields.js